import { makeSearchPage, makeSearchPageGssp } from "@/sections/buscar/makeSearchPage";

export const getServerSideProps = makeSearchPageGssp("cdmx");
export default makeSearchPage("cdmx");
